module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="filters-hook"></div>\n<div class="grid-50 costcentre-hook"></div>\n<div class="grid-50 settlement_account-hook"></div>\n\n<div class="list-hook"></div>\n\n<div class="actions-hook"></div>\n\n<div class="no_pending-hook"></div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./epayment_import/templates/layout.html
// module id = 213
// module chunks = 0